// Formata o número de uma conexão (só dígitos, como o backend grava).
// Brasil: 5511987654321 -> "(11) 9 8765-4321"; 551134567890 -> "(11) 3456-7890".
// Outros países: "+<dígitos>". Sem número: null.
const formatConnectionNumber = value => {
	if (!value) return null;
	const digits = String(value).replace(/\D/g, "");
	if (!digits) return null;

	if (digits.startsWith("55") && (digits.length === 12 || digits.length === 13)) {
		const ddd = digits.slice(2, 4);
		const rest = digits.slice(4);
		if (rest.length === 9) {
			return `(${ddd}) ${rest[0]} ${rest.slice(1, 5)}-${rest.slice(5)}`;
		}
		return `(${ddd}) ${rest.slice(0, 4)}-${rest.slice(4)}`;
	}

	return `+${digits}`;
};

export default formatConnectionNumber;
